import {Component} from '@angular/core';
import {AccountConfigurationService} from './account-configuration.service';
import {Router} from '@angular/router';

@Component({
    selector: 'itpx-account-configurations',
    templateUrl: './account-configurations.component.html',
    styleUrls: [ './account-configurations.component.css' ]
})
export class AccountConfigurationsComponent {

    constructor(
        private accountConfigurationService: AccountConfigurationService,
        private router: Router
    ) {}

    get accountConfigListTableConfig() {
        return [
            {
                title: 'Config Key',
                name: 'configKey',
                type: 'text',
                config: {
                    type: 'link',
                    route: '/agora/account-configurations/{{key}}/details',
                    key: 'id'
                }
            },
            {
                title: 'Config Value',
                name: 'configValue',
                type: 'text'
            },
            {
                title: 'Default Value',
                name: 'defaultValue',
                type: 'text'
            },
            {
                title: 'Group Type',
                name: (entity: any) => {
                    return entity.group.configType;
                },
                type: 'text'
            },
            {
                title: 'Domain',
                name: 'domain',
                type: 'text'
            },
        ];
    }

    getAccountConfigurationListAPIUrl() {
        return this.accountConfigurationService.getAccountConfigurationListAPIUrl();
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-configurations/account-configurations.component.ts